export const formatPropertyLabel = (property: {
  street?: string | null;
  postcode?: string | null;
  city?: string | null;
  name1?: string | null;
}): string => {
  const rawStreet = property.street ?? "";
  const hashIndex = rawStreet.indexOf("#");
  const street =
    hashIndex !== -1 ? rawStreet.slice(0, hashIndex).trim() : rawStreet.trim();
  const streetLabel =
    hashIndex !== -1 ? rawStreet.slice(hashIndex + 1).trim() : "";

  const labelParts = [streetLabel, property.name1?.trim()].filter(Boolean);
  const combinedLabel = labelParts.join(" ");

  const postcodeCity = [property.postcode?.trim(), property.city?.trim()]
    .filter(Boolean)
    .join(" ");

  const addressParts = [street, postcodeCity].filter(Boolean);
  const address = addressParts.join(", ");

  return [combinedLabel, address].filter(Boolean).join(" ");
};

export const parseAddress = (address: string | null | undefined) => {
  if (!address) {
    return { street: "", postcode: "", city: "" };
  }

  const [streetPart, rest] = address.split(",").map((s) => s.trim());

  if (!rest) {
    return { street: streetPart || "", postcode: "", city: "" };
  }

  const [postcode, ...cityParts] = rest.split(" ");

  return {
    street: streetPart || "",
    postcode: postcode || "",
    city: cityParts.join(" ") || "",
  };
};

export const parseAddressWithObject = (input?: string) => {
  if (!input) {
    return {
      street: "",
      objectName: "",
    };
  }

  const [streetPart, objectPart] = input.split("#");

  return {
    street: streetPart?.trim() ?? "",
    objectName: objectPart?.trim() ?? "",
  };
};